<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>

<div *ngIf="!accessdenied" class="row">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Purchased orders</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="col-md-12 col-sm-12 ">


            <div *ngIf="!isLoading" class="form-group col-md-12 col-sm-12 col-xs-12 " style="margin-bottom:20px">
                <div class="form-floating">
                    <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                    <label for="floatingInputValueSubject">Search for purchased order</label>
                </div>
            </div>

            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="po">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> PO# </th>
                        <td mat-cell *matCellDef="let row"> {{row.ContractNumber}} </td>
                    </ng-container>

                    <!-- Progress Column -->
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Start Date </th>
                        <td mat-cell *matCellDef="let row"> {{row.StartDate | date:'medium'}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> End Date </th>
                        <td mat-cell *matCellDef="let row"> {{row.EndDate | date:'medium'}} </td>
                    </ng-container>

                    <!-- Fruit Column -->
                    <ng-container matColumnDef="purchased">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Purchased </th>
                        <td mat-cell *matCellDef="let row">

                            {{row.Purchased}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="consumed">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Consumed </th>
                        <td mat-cell *matCellDef="let row"> {{row.Consumed}} </td>
                    </ng-container>

                    <ng-container matColumnDef="balance">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Balance </th>
                        <td mat-cell *matCellDef="let row"> {{row.Balance}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                        <td mat-cell *matCellDef="let row">
                            <small>
                                <span *ngIf="row.Status == 'In Delivery'" style="background-color: blue; padding: 3px; border-radius: 5px; color: white;">{{row.Status}}</span>
                                <span *ngIf="row.Status == 'Completed'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">{{row.Status}}</span>
                                <span *ngIf="row.Status == 'Cancelled'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">{{row.Status}}</span>
                                <span *ngIf="row.Status != 'In Delivery' && row.Status != 'Completed' && row.Status != 'Cancelled'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">{{row.Status}}</span>
                            </small>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="table_row" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
            </div>


        </div>

    </div>



</div>
<div class="row" style="margin-bottom: 15px;">

</div>
